import { render, staticRenderFns } from "./MbStudentListContent.vue?vue&type=template&id=eaaf04ac&"
import script from "./MbStudentListContent.vue?vue&type=script&lang=js&"
export * from "./MbStudentListContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports